import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { Button } from '@mui/material';

import useStores from 'hooks/use-stores';
import useTrialModal from 'hooks/use-trial-modal';
import { useAiInsightsCounter } from 'queries/bulletins/use-ai-insights-counter';

import ChevronUpDoubleIcon from './assets/chevron-up-double.svg';
import StarsIcon from './assets/stars.svg';
import useStyles from './styles';

interface Props {
    onLaunch?: () => void;
    className?: string;
}

const GenerationLauncher: React.FC<Props> = ({ onLaunch, className }) => {
    const { classes, cx } = useStyles();

    const { data } = useAiInsightsCounter();
    const { userStore } = useStores();

    const trialModal = useTrialModal();
    const history = useHistory();
    const goToUserInfo = useCallback(() => history.push('/userinfo'), [history]);

    if (!data) {
        return null;
    }

    const isTrial = userStore.user.isAnonymous || userStore.hasOnlyFreeLicense;

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.text}>
                <p className={classes.title}>
                    {data.limit === null ? null : (
                        <span className={classes.limits}>{`${Math.max(data.limit - data.count, 0)} of ${
                            data.limit
                        }`}</span>
                    )}
                    {'AI Insights are available for you today'}
                </p>
                <p className={classes.description}>
                    {'Leverage the power of AI to quickly understand vulnerabilities, impacts, and exploitability'}
                </p>
            </div>
            {data.limit === null || data.count < data.limit ? (
                <Button
                    variant="contained"
                    disableElevation
                    onClick={onLaunch}
                    className={classes.action}
                    startIcon={<StarsIcon />}
                >
                    {'Get AI Insights'}
                </Button>
            ) : (
                <>
                    <Button
                        variant="contained"
                        disableElevation
                        onClick={isTrial ? trialModal.onAnchorClick : goToUserInfo}
                        className={classes.action}
                        startIcon={isTrial ? null : <ChevronUpDoubleIcon />}
                    >
                        {isTrial ? 'Start 30-day trial' : 'Upgrade plan'}
                    </Button>
                    {trialModal.modal}
                </>
            )}
        </div>
    );
};

export default observer(GenerationLauncher);
